{
  "MACROS": {
    "HEADER": "Makronaredbe",
    "DESCRIPTION": "Makronaredba je skup spremljenih radnji koji agentima korisničke podrške olakšava izvršavanje zadataka. Agenti mogu definirati skup radnji, npr. dodavanje oznake razgovoru, slanje transkripta e-mailom ili ažuriranje prilagođenog atributa, i izvršiti ih jednim klikom.",
    "LEARN_MORE": "Saznajte više o makronaredbama",
    "HEADER_BTN_TXT": "Dodaj novu makronaredbu",
    "HEADER_BTN_TXT_SAVE": "Spremi makronaredbu",
    "LOADING": "Dohvaćanje makronaredbi",
    "ERROR": "Nešto je pošlo po zlu. Pokušajte ponovno",
    "ORDER_INFO": "Makronaredbe izvršavaju radnje redoslijedom kojim ste ih dodali. Redoslijed možete promijeniti povlačenjem ručke pokraj svakog čvora.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Naziv makronaredbe",
          "PLACEHOLDER": "Unesite naziv makronaredbe",
          "ERROR": "Naziv je obavezan za kreiranje makronaredbe"
        },
        "ACTIONS": {
          "LABEL": "Radnje"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Makronaredba uspješno dodana",
        "ERROR_MESSAGE": "Kreiranje makronaredbe nije uspjelo. Pokušajte kasnije"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Ime",
        "CREATED BY": "Kreirao",
        "LAST_UPDATED_BY": "Zadnje ažurirao",
        "VISIBILITY": "Vidljivost"
      },
      "404": "Nema pronađenih makronaredbi"
    },
    "DELETE": {
      "TOOLTIP": "Izbriši makronaredbu",
      "CONFIRM": {
        "MESSAGE": "Jeste li sigurni da želite izbrisati ",
        "YES": "Da, izbriši",
        "NO": "Ne"
      },
      "API": {
        "SUCCESS_MESSAGE": "Makronaredba uspješno izbrisana",
        "ERROR_MESSAGE": "Došlo je do greške pri brisanju makronaredbe. Pokušajte kasnije"
      }
    },
    "EDIT": {
      "TOOLTIP": "Uredi makronaredbu",
      "API": {
        "SUCCESS_MESSAGE": "Makronaredba uspješno ažurirana",
        "ERROR_MESSAGE": "Ažuriranje makronaredbe nije uspjelo. Pokušajte kasnije"
      }
    },
    "EDITOR": {
      "START_FLOW": "Početak tijeka",
      "END_FLOW": "Kraj tijeka",
      "LOADING": "Dohvaćanje makronaredbe",
      "ADD_BTN_TOOLTIP": "Dodaj novu radnju",
      "DELETE_BTN_TOOLTIP": "Izbriši radnju",
      "VISIBILITY": {
        "LABEL": "Vidljivost makronaredbe",
        "GLOBAL": {
          "LABEL": "Javno",
          "DESCRIPTION": "Ova makronaredba je javno dostupna svim agentima u ovom računu."
        },
        "PERSONAL": {
          "LABEL": "Privatno",
          "DESCRIPTION": "Ova makronaredba bit će privatna i dostupna samo vama."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Izvrši",
      "PREVIEW": "Pregled makronaredbe",
      "EXECUTED_SUCCESSFULLY": "Makronaredba uspješno izvršena"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Ključ atributa je obavezan",
      "FILTER_OPERATOR_REQUIRED": "Operator filtra je obavezan",
      "VALUE_REQUIRED": "Vrijednost je obavezna",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Vrijednost mora biti između 0 i 998",
      "ACTION_PARAMETERS_REQUIRED": "Parametri radnje su obavezni",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Potreban je barem jedan uvjet",
      "ATLEAST_ONE_ACTION_REQUIRED": "Potrebna je barem jedna radnja"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Dodijeli timu",
      "ASSIGN_AGENT": "Dodijeli agentu",
      "ADD_LABEL": "Dodaj oznaku",
      "REMOVE_LABEL": "Ukloni oznaku",
      "REMOVE_ASSIGNED_TEAM": "Ukloni dodijeljeni tim",
      "SEND_EMAIL_TRANSCRIPT": "Pošalji transkript e-mailom",
      "MUTE_CONVERSATION": "Utišaj razgovor",
      "SNOOZE_CONVERSATION": "Odgodi razgovor",
      "RESOLVE_CONVERSATION": "Riješi razgovor",
      "SEND_ATTACHMENT": "Pošalji privitak",
      "SEND_MESSAGE": "Pošalji poruku",
      "CHANGE_PRIORITY": "Promijeni prioritet",
      "ADD_PRIVATE_NOTE": "Dodaj privatnu bilješku",
      "SEND_WEBHOOK_EVENT": "Pošalji webhook događaj"
    },
    "ACTION_VALUES": {
      "SELF": "Ja"
    }
  }
}
